<template>
    <div class="about-sw" style="/*display: table-cell;*/vertical-align: middle;text-align: center;">
        <!-- ============= 顶部背景图 ============= -->
        <div style=' margin: 0px auto;background: rgba(0, 0, 0, 0) url("web/bk/bk1.png") repeat scroll 0% 0% / 100%;'>
            <img src="../../assets/images/about/banner.png" style="height: 505px; width: 1300px;display: block;margin: 0px auto;">
        </div>

        <!-- ============= 企业简介 ============= -->
        <div class="about-message" style="display: inline-block;width: 1200px;text-align: left">
            <div style="font-size: 36px"><h1 style="text-align: center;font-size: 36px;">企业简介</h1></div>
            <div>
                <div style="float: right">
                    <img src="../../assets/images/about/tp.png">
                </div>
                <div style="white-space: pre-wrap;text-indent: 35px;line-height: 27px;">
            中颖电子股份有限公司成立于1994年7月，于2012年在深圳创业板上市（股票代码：中颖电子300327）。主营业务为自主品牌的芯片设计及销售，并提供相应的系统解决方案和售后的技术支持服务。
            主营产品为MCU（工业控制微控制器芯片）、BMIC（锂电池管理芯片）和AMOLED（显示驱动芯片）。MCU微控制器系统主控单芯片主要用于家电主控、电机控制、智能电表及物联网领域。BMIC锂电池管理芯片主要用于锂电池的计量和保护。AMOLED显示驱动芯片主要用于手机和可穿戴产品的屏幕显示驱动。
            公司系高新技术企业、上海市企业技术中心、上海市民营企业总部型企业。荣获上海市专利工作试点示范单位、上海市知识产权优势企业等荣誉。
            公司秉承“勤于心.精于技”的企业精神，追求无止尽的创新。以一流产品质量与服务满足国际化大客户需求，以诚信经营建构合作伙伴关系，赢得客户的信赖，成就全球性竞争力。
                </div>
                <div style="line-height: 27px;">
                销售邮箱(大陆):<a href="mailto:sales.sh@sinowealth.com" class="blue12px">sales.sh@sinowealth.com</a><br>
                销售邮箱(海外):<a href="mailto:sales.hk@sinowealth.com.hk" class="blue12px">sales.hk@sinowealth.com.hk</a><br>
                招聘邮箱&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:<a href="mailto:HR@sinowealth.com" class="blue12px">HR@sinowealth.com </a><br>
                投资人邮箱&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:<a href="mailto:IR@sinowealth.com" class="blue12px">IR@sinowealth.com</a><br>
                </div>
            </div>
            <!--div style="height: 420px">
                <div style="float: left">
                    <img src="../../assets/images/about/tp.png">
                </div>

                <div style="float: left;text-align: left;margin-left: 80px">
                    <h2>中颖电子</h2>
                    <p style="color:rgba(153,153,153,1);">SinoWealth</p>
                    <h2 >国产化锂电控制芯片中国市场的领先者</h2>
                    <p style="width: 560px;height: 180px;color:rgba(51,51,51,1);">中颖电子股份有限公司(股票编号SZ300327)是一家专注于单片机集成电路设计与销售的高新公司，
                      是首批被中国工业及信息化部及上海市信息化办公室认定的集成电路设计企业，并连续数年被评定为“上海市高新技术企业”。</p>
                </div>
              <img src="../../assets/images/about/weizhankai.png" style="margin-top: 20px" @click="mores()" v-if="!moreShow">
            </div>


            <div  style="display: inline-block;text-align: left;height: 280px" v-if="moreShow">
                <div style="font-size: 36px"><h2 style="text-align: left;font-size: 24px;">白色家电控制芯片中华区厂商排名第一</h2></div>
                <p  style="width: 1280px;height: 220px;color:rgba(51,51,51,1);width: 1000px">中颖电子本着专业专精的精神,专注于于单片机(MCU)产品集成电路设计.
                    MCU母体包括8-bit Flash MCU、8-bit OTP/Mask MCU、16-bit DSP、4-bit OTP/Mask MCU,并广泛应用于家电、白色家电、黑色家电、汽车电子周边、运动器材、
                    医疗保健四表（水、电、气、暖）、仪器仪表、安防、电源控制、马达控制、工业控制、变频、数码电机、计算机键盘、鼠标、网络音乐（便携式、车载、床头音响）、无线儿童监控器、
                    无线耳机/喇叭/门铃. 中颖电子经过多年努力,结合MCU的开发经验,采用高压制程,开拓了锂电池管理和保护产品线.产品广泛应用于笔记本电脑、智能手机、平板电脑、电动工具、
                    电动自行车、UPS和移动基站等领域的锂电池管理和保护.同时,还扩充了OLED系列产品,以环保节能 的先进理念揭开新的篇章</p>
            </div>

            <div style="height: 420px;width: 1200px;" v-if="moreShow">
                <div style="float: left;display: inline-block">
                    <img src="../../assets/images/about/tp2.png">
                </div>
                <div style="float: left;margin-left: 80px;text-align: left">
                    <h2>小家电控制芯片中国市场排名第一</h2>
                    <p style="width: 520px;height: 315px;color:rgba(51,51,51,1);">中颖电子根植中国,贴近市场,贴近客户,坚持专业化、差异化、成本化的经营策略,不断增强自身的核心竞争力及价值,协助终端客户持续降低不良率和返修率,提高生产直通率,建立了良好的质量可靠度形象.相信在既有团队的努力及产能的充分支持下,必能支持您大幅提升竞争力,同时我们也将鞭策自己在产品与服务上进一步提升质量,迈入新境界,使客户及我们自己都能在这激烈的竞争中更为突出、领先。</p>
                </div>
            </div>

            <div style="height: 120px;width: 1100px;text-align: left;margin-left: 30px" v-if="moreShow">
                <p style="color:rgba(51,51,51,1);">我们秉承"先有客户的成功,才有我们的成功"的理念,坚持"以客户满意为指标"的宗旨,继续不懈努力,不断创新,为客户提供质量稳定、高一致性、高性价比的产品和高效的服务.我们期待与您更加密切的合作,集合作伙伴之力以达到双赢. </p>
            </div-->

          <img src="../../assets/images/about/shouqi.png" style="margin-top: 20px" @click="mores()" v-if="moreShow">
        </div>
        <!-- ============= 企业文化 ============= -->
        <div class="about-culture">
          <div class="about-culture-content">
            <h1 class="about-culture-content-title">企业文化</h1>
            <div style="margin: 0px auto;font-size: 22px;width: 1200px;">
              <div class="about-culture-one" style="padding: 0 10px;">
                <p style="margin: 120px auto 40px auto;font-size: 32px;font-weight: 600;">我们的愿景</p>
                <p>大中华地区最大且国际知名的MCU芯片设计公司，根基长青且永续稳固的卓越标竿企业。</p>
              </div>
              <div class="about-culture-two" style="padding: 0 10px;">
                <p style="margin: 120px auto 40px auto;font-size: 32px;font-weight: 600;">核心价值</p>
                <p>以人为本，诚信为用，专注深耕，绩效导向，引领全体员工向前奋进，形塑『勤于心·精于技』的文化底蕴。</p>
              </div>
              <div class="about-culture-three" style="padding: 0 10px;">
                <p style="margin: 120px auto 40px auto;font-size: 32px;font-weight: 600;">经营理念</p>
                <p>无止尽的创新，以一流的产品质量与服务满足国际化大客户需求，并以诚信经营构建合作伙伴与客户的信赖，成就全球性竞争力。</p>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showMore: false,
                isLongContent: false,
                certificate: 0,
                softwareCopyright: [
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                ],
                patentCertificate: [
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                ],
                otherList: [
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                    '../../assets/images/about/zs.png',
                ],
                moreShow: false // 更多显示
            }
        },

        mounted() {

        },

        watch:{
            content () {
                this.calculateHeight()
            }
        },

        methods: {
            calculateHeight () {
                // $nextTick()，等待内容获取完毕再计算高度，异步处理
                this.$nextTick().then(() => {
                    let contentHeight = this.$refs.content.clientHeight
                    if (contentHeight > this.showHeight) {
                        this.isLongContent = true
                    } else {
                        this.isLongContent = false
                    }
                })
            },

            reload:function (index) {
                this.certificate = index
                // window.location.reload();
            },
            mores() {
                this.moreShow = !this.moreShow
            }
        }
    }
</script>

<style>
  .about-sw .about-culture { height: 666px;background: url("../../assets/images/about/beijingtu.png");background-size: cover;}
  .about-culture-content {width: 68%;margin: 0 auto;padding-top: 60px;}
  .about-culture-content-title {font-size: 48px;color: #ffffff;margin: 0;padding-bottom: 60px;}
  .about-culture .about-culture-one { margin: 0 10px;padding: 0;width: 30%;height: 408px;background-color: white;float: left }
  .about-culture .about-culture-two { margin: 0 10px;padding: 0;width: 30%;height: 408px;background-color: white;float: left }
  .about-culture .about-culture-three { margin: 0 10px;padding: 0;width: 30%;height: 408px;background-color: white;float: left }
  .about-sw .about-certificate { height: 640px;text-align: center;width: 70%;display: inline-block;overflow:auto; }
  .about-sw .about-certificate > img { margin-left: 120px }
  .about-sw .about-certificate > ul > li { list-style:none;float: left;margin-left: 25px;}
  .about-sw .about-certificate .about-certificate-ul {list-style-type:none;cursor:pointer;margin-top: 60px;width: 1200px;transition:opacity 1s;
    animation:bounce-in 3s;
  }
  @keyframes bounce-in{
    0%{transform:scale(0);}
    100%{transform:scale(1);}
  }
  .about-sw .about-certificate .titleType {color: #4A90E2;}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue